import { all, call, put, takeLatest, select } from 'redux-saga/effects';
import {
  handleFetchAffiliateData,
  handleSaveAffiliateData,
} from './affiliate.helpers';
import { affiliateTypes } from './affiliate.types';
import {
  fetchAffiliateDataSuccess,
  fetchAffiliateDataFailure,
  saveAffiliateDataSuccess,
  saveAffiliateDataFailure,
} from './affiliate.actions';
import { handleErrors, getNotifMsg } from 'utils';
import { toast } from 'react-toastify';

const mapState = ({ appData }) => ({
  locale: appData.locale,
});

export function* fetchAffiliateDataSaga() {
  const { locale } = yield select(mapState);
  try {
    const response = yield call(handleFetchAffiliateData);
    yield put(fetchAffiliateDataSuccess(response));
  } catch (error) {
    yield put(fetchAffiliateDataFailure(error));
    handleErrors(error, locale);
  }
}

export function* saveAffiliateDataSaga(action) {
  const { locale } = yield select(mapState);
  try {
    const response = yield call(handleSaveAffiliateData, action.payload);
    yield put(saveAffiliateDataSuccess(response));
    yield put({ type: affiliateTypes.FETCH_AFFILIATE_DATA });

    if (response.success && action.payload.request) {
      toast.success(getNotifMsg('REQUEST_SUBMITED_SUCCESS', locale));
      return;
    }
    toast.success(getNotifMsg('INFO_SAVED_SUCCESS', locale));
  } catch (error) {
    yield put(saveAffiliateDataFailure(error));
    handleErrors(error, locale);
  }
}

export function* onFetchingAffiliateData() {
  yield takeLatest(affiliateTypes.FETCH_AFFILIATE_DATA, fetchAffiliateDataSaga);
}

export function* onSavingAffiliateData() {
  yield takeLatest(affiliateTypes.SAVE_AFFILIATE_DATA, saveAffiliateDataSaga);
}

export default function* affiliateSaga() {
  yield all([call(onFetchingAffiliateData), call(onSavingAffiliateData)]);
}
